var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alipaySendPage"},[_c('XR-head',{attrs:{"titleText":"支付宝支付","rightShow":false}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v(" "),_c('XR-toast',{ref:"XRtoast"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4923b3c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/retail/pay/alipaySend.vue
// module id = null
// module chunks = 